var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isDispTitle && _vm.post.title
        ? _c("h1", { staticClass: "title" }, [
            _vm._v("\n    " + _vm._s(_vm.post.title) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.post.bodyHtml
        ? _c("post-body", { attrs: { body: _vm.post.bodyHtml } })
        : _vm._e(),
      _vm._v(" "),
      _c("EbImages", {
        attrs: { images: _vm.post.images, targetServiceId: _vm.post.serviceId },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "block mt-5" }, [
        _c("label", { staticClass: "has-text-weight-medium" }, [
          _vm._v(_vm._s(_vm.$t("term.requiredTimeToAnswer"))),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "ml-4" }, [
          _vm._v(_vm._s(_vm._f("numFormat")(_vm.post.requiredTime / 60))),
        ]),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "has-text-grey is-size-7 has-text-weight-light" },
          [_vm._v("\n      (" + _vm._s(_vm.$t("form.unitMinites")) + ")\n    ")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }